import { useGetOwnIntegratorFeaturesQuery } from '@/api/v1';

export const useDisplayUsdcAsUsd = (): boolean => {
  const { data: integratorFeatures } = useGetOwnIntegratorFeaturesQuery();

  return integratorFeatures?.displayUsdcAsUsd ?? false;
};
